import { createSelector } from 'reselect';
import _ from 'lodash';

import * as TableBasedInventory from 'types/tableBasedInventory';
import detailedSquaresByDateTimeSelector from 'selectors/routes/calendar/detailedCalendarSquaresSelector';

export interface CalendarSquaresByTable {
  [tableId: string]: TableBasedInventory.NormalDetailedSquare[];
}

function computeCalendarSquaresByTable(
  allCalendarSquares: TableBasedInventory.NormalDetailedSquare[]
): CalendarSquaresByTable {
  return _.groupBy(allCalendarSquares, (calendarSquare) => calendarSquare.tableId);
}

export const calendarSquaresByTableSelector = createSelector(
  detailedSquaresByDateTimeSelector,
  computeCalendarSquaresByTable
);
